module.exports = __webpack_public_path__ + "img/treuchtlingen_logo.d804da5.png";